export default class FacturesPrintController {
	/* @ngInject*/
	constructor(
		$scope,
		$state,
		$stateParams,
		ModalService,
		FacturesService,
		notification,
		$translate,
		$filter,
		_,
		$uibModal,
		SettingPortailService,
		DomainesService
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.ModalService = ModalService;
		this.FacturesService = FacturesService;
		this.notification = notification;
		this.$translate = $translate;
		this.$filter = $filter;
		this.$uibModal = $uibModal;
		this.SettingPortailService = SettingPortailService;
		this.DomainesService = DomainesService;
	}

	async $onInit() {
		this.startLoading();

		this.printMode = (await this.FacturesService.getPrintMode()).map((x) => ({ ...x, libelle: this.$translate.instant(x.libelle) }));
		const isDomainePortailActif = await this.DomainesService.isDomainActif('Portail');
		this.printOption = {
			isRectoVerso: false,
			isFacture: true,
			isTraite: false,
			isReleve: false,
			isTraiteFusion: false,
			isDuplicata: false,
			haveSeparateFiles: false,
			showFactureSoldee: false,
			sendToPortail: false,
			showSendToPortail: false,
			sendBlToPortail: false,
			showBlSendToPortail: false,
			printMode: this.printMode[0],
			isDomainePortailActif: isDomainePortailActif
		};

		this.invalidesChecked = false;
		if (
			!this.resolve.allFacturesOptions ||
			!this.resolve.allFacturesOptions.count ||
			this.resolve.allFacturesOptions.count == this.resolve.source.length
		) {
			this.factureInvalides = await this.FacturesService.getFactureInvalides(this.resolve.source);
			this.invalidesChecked = true;
		}

		const factureDocSetting = await this.SettingPortailService.getDocSetting('FACT');
		if (factureDocSetting && factureDocSetting.data) {
			this.printOption.sendToPortail = factureDocSetting.data.envoiAuto;
			this.printOption.showSendToPortail = factureDocSetting.data.envoiAuto;
		}
		const blDocSetting = await this.SettingPortailService.getDocSetting('RLV');
		if (blDocSetting && blDocSetting.data) {
			this.printOption.sendBlToPortail = blDocSetting.data.envoiAuto;
			this.printOption.showBlSendToPortail = blDocSetting.data.envoiAuto;
			this.printOption.isReleve = blDocSetting.data.envoiAuto;
		}

		this.disableSendToPortail = false;
		if (this.resolve.source.length == 1) {
			const facture = await this.FacturesService.getFactureById(this.resolve.source[0]);
			//Si elle est seule et pas en etat cloturee ou comptabilisee, on désactive l'envoie
			if (facture.idEtatFacture != 1 && facture.idEtatFacture != 3) {
				this.disableSendToPortail = true;
				this.printOption.sendToPortail = false;
			}
		}

		this.stopLoading();
	}

	async generatePrint(fileName = null) {
		let resultat = null;
		if (this.resolve.allFacturesOptions && this.resolve.allFacturesOptions.count > 0) {
			resultat = await this.FacturesService.printAll(this.resolve.source, fileName, this.printOption, this.resolve.allFacturesOptions);
		} else resultat = await this.FacturesService.print(this.resolve.source, fileName, this.printOption);
		return resultat;
	}

	async print() {
		const fileName = Date.now();
		if (this.resolve.source.length > 0) {
			this.startLoading();
			if (!this.printOption.isTraite) {
				this.printOption.isTraiteFusion = false;
			}

			try {
				let resultat = await this.generatePrint(fileName);
				const data = resultat.data;
				let headers = resultat.headers;
				headers = headers();
				const contentType = headers['content-type'];
				const linkElement = document.createElement('a');

				try {
					const blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
					const url = window.URL.createObjectURL(blob);
					linkElement.setAttribute('href', url);
					linkElement.setAttribute('download', fileName + (this.printOption.haveSeparateFiles ? '.zip' : '.pdf'));

					const clickEvent = new MouseEvent('click', {
						view: window,
						bubbles: true,
						cancelable: false
					});
					linkElement.dispatchEvent(clickEvent);
				} catch (ex) {
					console.log(ex);
				} finally {
					const response = await this.FacturesService.getMessageErreur();
					if (response) {
						this.ModalService.info({
							modalTitle: this.$translate.instant('FACTURES.BREADCRUMBS.FACTURES_LIST'),
							modalMsg: response,
							headerClass: 'modal-info'
						});
					}
					this.stopLoading();
					this.modalInstance.close(true);
				}
			} catch (ex) {
				console.log(ex);

				if (!('TextDecoder' in window)) {
					this.notification.error('Sorry, this browser does not support TextDecoder...');
				}

				const enc = new TextDecoder('utf-8');
				this.notification.error(enc.decode(ex.data));
			}
		}
	}

	async cancel() {
		this.modalInstance.dismiss();
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	onChangeFacture() {
		this.printOption.sendToPortail = this.printOption.isFacture;
	}

	onChangeReleve() {
		this.printOption.sendBlToPortail = this.printOption.isReleve;
	}

	async processDocuments() {
		try {
			const { id: printModeId } = this.printOption.printMode;

			switch (printModeId) {
				case 0:
					await this.handlePrintAndCancel();
					break;

				case 1:
					await this.handleGenerateAndSend();
					break;

				case 2:
					await this.handlePrintAndSend();
					break;

				default:
					await this.handlePrintAndCancel();
					break;
			}
		} catch (error) {
			console.log(error);
		}
	}

	async handlePrintAndCancel() {
		await this.print();
		await this.cancel();
	}

	async handleGenerateAndSend() {
		this.startLoading();

		try {
			// check si les factures sont archivé, sinon lancé le PrintFactureService.cs
			const unarchvedFactureIdList = await this.FacturesService.checkIfArchivageFactureExist(
				this.resolve.selectedFactures.map((x) => x.id),
				this.printOption.isFacture,
				this.printOption.isReleve,
				this.printOption.isTraite
			);

			if (unarchvedFactureIdList.length > 0) {
				this.resolve.source = unarchvedFactureIdList;
				await this.generatePrint();
			}
		} finally {
			this.stopLoading();
		}

		await this.cancel();

		try {
			await this.sendMail();
		} catch (mailError) {
			console.log(mailError);
		}
	}

	async handlePrintAndSend() {
		// angular.element(document.querySelector('.print-facture-modal')).addClass('hidden');
		this.startLoading();
		try {
			await this.print();
			await this.sendMail();
		} catch (mailError) {
			console.log(mailError);
		} finally {
			this.stopLoading();
		}
	}

	sendMail = async () => {
		try {
			const mailDestinataireModal = this.ModalService.open({
				component: 'ModaleChooseDestinataire',
				resolve: {
					idSociete: () => this.resolve.idSociete,
					selectedFactures: () => this.resolve.selectedFactures
				},
				animation: true,
				size: 'xxl',
				windowClass: 'modern-modal'
			});

			const res = await mailDestinataireModal.result;
			if (res.length > 0) {
				this.isSendingMail = true;
				this.notification.info(this.$translate.instant('FACTURES.ENVOI_MAIL_START'));
				var response = await this.FacturesService.sendFacturesByMail(
					res,
					this.printOption.isFacture,
					this.printOption.isReleve,
					this.printOption.isTraite,
					this.printOption.haveSeparateFiles
				);
				let r = '';
				if (response?.length > 0) {
					response.forEach(function (element) {
						r = r + element + '<br />';
					}, this);

					this.ModalService.info({
						modalTitle: this.$translate.instant('FACTURES.BREADCRUMBS.FACTURES_LIST'),
						modalMsg: r,
						headerClass: 'modal-info'
					});
				} else {
					this.notification.success(this.$translate.instant('FACTURES.ENVOI_MAIL_FIN'));
				}
			}
		} catch (ex) {
			console.log(ex);
		} finally {
			this.isSendingMail = false;
		}
	};
}
